import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";
interface WelcomeSectionProps {
  data?: {
    welcome_message?: string;
  };
}
export const WelcomeSection = ({
  data
}: WelcomeSectionProps) => {
  if (!data) {
    return null;
  }
  const signatureVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        staggerChildren: 0.05
      }
    }
  };
  const letterVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100
      }
    }
  };
  const AnimatedText = ({
    text
  }: {
    text: string;
  }) => <motion.span variants={signatureVariants} initial="hidden" animate="visible" className="inline-block">
      {text.split("").map((char, index) => <motion.span key={index} variants={letterVariants} className="inline-block">
          {char}
        </motion.span>)}
    </motion.span>;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }}>
      <Card className="shadow-lg border-none">
        <CardContent className="space-y-6 p-8">
          <div className="space-y-4 text-left">
            <h2 className="text-4xl font-bold text-primary mb-6">
              Welcome to Supplyfied
            </h2>
            <p className="text-gray-700 text-lg">Dear Investor,</p>
            <p className="text-gray-700 text-lg">
              Supplyfied was founded with a single mission — to transform how hotels source, manage, and comply with procurement standards through technology. Over the past years, we’ve navigated shifting markets, ambitious national projects, and global challenges, each shaping our strategy and sharpening our focus.
            </p>
            <p className="text-gray-700 text-lg">
              Today, we stand at a critical inflection point. Our AI-powered platform is live, our pipeline is expanding with high-value opportunities, and our market position is clearer than ever. As we transition into the next phase, we’re strengthening governance and operational depth to ensure sustained execution and scalability.
            </p>
            <p className="text-gray-700 text-lg">
              This Investors Hub offers a transparent view of our journey, traction, and plans. Inside, you’ll find the milestones we’ve reached, the market we’re addressing, the technology driving our advantage, and the roadmap that will take us forward. Our goal is simple: keep you informed, aligned, and part of a growth story that is built to last.
            </p>
            <p className="text-gray-700 text-lg">Thank you for your trust and partnership.</p>
            
            <motion.div className="mt-8 pl-4 border-l-4 border-primary/50" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3
          }}>
              <p className="text-gray-700">Warm regards,</p>
              <motion.p className="text-4xl my-2 font-signature" style={{
              background: "linear-gradient(45deg, #0FA0CE, #00BFA6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}>
                <AnimatedText text="Ahmed Hakami" />
              </motion.p>
              <p className="text-[#000000e6]">
                Founder & CEO
              </p>
              <p className="text-gray-700">Supplyfied</p>
            </motion.div>
          </div>
        </CardContent>
      </Card>
    </motion.div>;
};